import axios from 'utils/api';
import {
  extractRecommendedCodes,
  flattenWantRecommendations,
  RecommendationsResult
} from 'utils/recommendations-strip-logic';

// The recommended codes for saved wants when there is no current system to
// anchor on (no existing equipment, or none the derivation could identify):
// the same no-current-system POST the strip fires, so the Choose Systems
// healer derives the bound the Equipment Details step would have. The
// server resolves each want's current-agnostic list (its like-for-like
// scenarios), which is how a plain "Heat Pump" want reaches the Next Gen
// types the picker never offers. A failed request yields [] so the caller
// can fall back to the want types' own codes instead of skipping.
export async function fetchNoCurrentSystemCodes(
  wantIds: number[]
): Promise<string[]> {
  try {
    const response = await axios.post<RecommendationsResult>(
      '/existing-equipment/recommendations',
      { noCurrentSystem: true, desiredSystemTypeIds: wantIds }
    );
    return extractRecommendedCodes(
      flattenWantRecommendations(response.data?.recommendationsByWant)
    );
  } catch (error) {
    console.error(
      '[ducted-compatibility] no-current-system recommendations failed:',
      error
    );
    return [];
  }
}
